import React from "react";

const Footer = () => {
  // const { textsilver } = useContext(ThemeContext).theme.COLORS

  // const { t } = useTranslation()

  return null;

  // return (
  // 	<FooterContainer>
  // 		<FooterWrapper>
  // 			<Copyright>
  // 				<CopyrightText>
  // 					<CText
  // 						text={t('copyRight')}
  // 						style={{
  // 							...FONTS.h5,
  // 							fontSize: 14,
  // 							fontWeight: '500',
  // 							color: textsilver,
  // 						}}
  // 					/>
  // 				</CopyrightText>
  // 			</Copyright>
  // 		</FooterWrapper>
  // 	</FooterContainer>
  // )
};

export default React.memo(Footer);
